import { render, staticRenderFns } from "./iinstall_dev.vue?vue&type=template&id=39a18ed9&scoped=true&"
import script from "./iinstall_dev.vue?vue&type=script&lang=ts&"
export * from "./iinstall_dev.vue?vue&type=script&lang=ts&"
import style0 from "./iinstall_dev.vue?vue&type=style&index=0&id=39a18ed9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a18ed9",
  null
  
)

export default component.exports